import React, { useState } from "react";
import { Row } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { editIcon, viewIcon } from "../../assets/img";

const Bookings = ({
  getBookings,
  setBookingPage,
  paginationBooking,
  bookingCount,
  bookingRow,
  bookings,
}) => {
  const navigate = useNavigate();

  const handlePageChange = (selectedObject) => {
    setBookingPage(selectedObject.selected + 1);
  };
  return (
    <div>
      {" "}
      <Row md={12} sm={12} lg={12}>
        <div className="col-md-6 mt-5">
          <label className="table-labels f1">
            Total Count : {paginationBooking?.total}
          </label>
        </div>
      </Row>
      <div className="d-flex ac-jb ">
        <div className="col-md-2 p-0">
          <select
            className="form-control custom-select"
            onChange={(e) => getBookings(e.target.value)}
            value={bookingRow}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
      <div className="table-custom-design overflow-scroll">
        <table>
          <thead className="single-book-table">
            <tr className="text-capitalize text-nowrap">
              <th>S.NO</th>
              <th>Booking ID</th>
              <th>Image</th>
              <th>Property Name</th>
              <th>Category</th>
              <th>Price(₹)</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {bookings?.map((item, ind) => {
              return (
                <tr key={ind}>
                  <td>
                    {(paginationBooking?.current_page - 1) * bookingRow +
                      ind +
                      1}
                  </td>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() =>
                        navigate("/booked-rooms-view", {
                          state: { data: item },
                        })
                      }
                    >
                      {item?.booking_id}
                    </button>
                  </td>
                  <td>
                    <img
                      src={item?.property?.name}
                      style={{ width: "100px", height: "80px" }}
                      alt="property-img"
                      class="img-fluid"
                    />
                  </td>
                  <td>{item?.property?.name}</td>
                  <td>{item?.service_type}</td>
                  <td>{item?.total_payable_amount}</td>
                  <td className="text-success">
                    {item?.check_in != "null"
                      ? "Check in"
                      : item?.check_out != "null"
                      ? "Check Out"
                      : "Booked"}
                  </td>
                  <td>
                    <button
                      className="cust-btn"
                      onClick={() =>
                        navigate("/booked-rooms-view", {
                          state: { type: "view", data: item },
                        })
                      }
                    >
                      <img src={viewIcon} className="edit-btn" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="page-inner-cont py-2 d-flex justify-content-end">
        <ReactPaginate
          nextLabel="››"
          onPageChange={handlePageChange}
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
          pageCount={bookingCount}
          previousLabel="‹‹"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default Bookings;
